<section class="activity-loyalty">
  <h3>{{ 'activity.loyalty.title' | translate }}</h3>
  <p class="activity-loyalty__details">
    {{ 'activity.loyalty.points' | translate }}
  </p>
  <p *ngIf="ecological" class="activity-loyalty__bonus">
    {{ 'activity.loyalty.ecological_bonus' | translate }}
  </p>
  <a
    *ngIf="link"
    class="activity-loyalty__link"
    [href]="link"
    rel="noreferrer noopener"
    target="_blank"
  >
    {{ 'activity.loyalty.club' | translate }}
    <vtmn-play-icon
      class="activity-loyalty__icon"
      [name]="iconType.ArrowRight"
    ></vtmn-play-icon>
  </a>
  <img
    class="activity-loyalty__image"
    src="assets/loyalty-points/loyalty-points.svg"
    [alt]="'activity.loyalty.image' | translate"
  />
</section>
